import { Dialog } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { locationGroupVisible } from "../../../../store/locationGroup";
import { withRouter } from "react-router";
import { loadLocationGroup } from "../../../LocalDeals/modules/localDealsModule";
import { metersToMiles } from "../../../LocalDeals/helpers/distanceHelper";
import "./LocationGroupModal.scss";


class LocationGroupModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isOpen: this.props.isOpen,
            deals: [],
        };
    }

    loadDealLocations = (deal_id, brand_id) => {
        this.props.loadLocationGroup(deal_id, brand_id).then((resp)=>{
            this.setState({ deals: resp.data.promotions });
        })
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.deal_id && (this.props.deal_id !== prevProps.deal_id || !this.state.deals.length)) {
            this.loadDealLocations(this.props.deal_id, this.props.brand_id);
        }
    };

    closeModal = () => {
        this.props.changeVisible(false);
    }

    handleClickLocations = (deal) => {
        this.props.router.push("/deals/" + deal.id);
        this.closeModal();
    }

    render() {
        const { imageURL, isOpen } = this.props;
        const {deals, isLoading} = this.state;


        return (<Dialog
            open={isOpen}
            onClose={this.closeModal}
            className="DialogLocationGroupModal"
        >
            {isLoading ? <span>Loading...</span> :
                <div className="LocationGroupModal">
                    <div className="LocationModalText text-center">
                        This Deal Is only valid at the location(s) you select below.
                    </div>
                    <div className="LocationModalText secondary text-center">
                        Please choose where you would like to use this deal.
                    </div>
                    <img src={imageURL} alt="deal-ico" className="deal-image"/>
                    <div className="location-groups-wrapper">
                        {deals.map((deal) => (
                            <div key={"loc-gr-" + deal.id} className="location-group d-flex justify-content-between">
                                <div>
                                    {deal.locations.map((l, i) => (<div key={"loc-" + i}>
                                        {l.address.street_1 + ', ' + l.address.city + " ○ " + (l.address.distance ? metersToMiles(l.address.distance) +  ' ml'  : '') + "\n (" + l.address.city + ")"}
                                    </div>))}
                                </div>
                                <button type="button" onClick={() => this.handleClickLocations(deal)}
                                        className="btn btn-success">
                                    {deal.locations.length > 1 ? 'CHOOSE THESE LOCATIONS' : 'CHOOSE THIS LOCATION'}
                                </button>

                            </div>))}
                    </div>
                    <button
                        type="button"
                        onClick={this.closeModal}
                        className="btn btn-grey"
                    >
                        CLOSE
                    </button>
                </div>
            }
        </Dialog>);
    }
}

const mapStateToProps = (state, props) => {
    return {
        isOpen: state.locationGroup.show,
        locationGroups: state.locationGroup.data.locationGroups,
        imageURL: state.locationGroup.data.image,
        deal_id: state.locationGroup.data.deal_id,
        brand_id: state.locationGroup.data.brand_id
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadLocationGroup: (deal_id, brand_id) => dispatch(loadLocationGroup(deal_id, brand_id)),
        changeVisible: (value) => dispatch(locationGroupVisible(value))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationGroupModal));



// WEBPACK FOOTER //
// ./src/routes/Home/components/LocationGroupModal/LocationGroupModal.js